(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('.ts-bq-comparison--model').forEach((comparison) => {
      const select = comparison.querySelector('[data-ts-bq-sort]');
      const container = comparison.querySelector('[data-ts-bq-rows]');
      if (!select || !container || select.dataset.tsBqSortReady === 'true') return;
      const rows = Array.from(container.children);
      if (!rows.length || rows.some((row) => !row.hasAttribute('data-ts-bq-row')
        || !Number.isSafeInteger(Number(row.dataset.price)) || Number(row.dataset.price) <= 0
        || !Number.isSafeInteger(Number(row.dataset.count)) || Number(row.dataset.count) < 0
        || !row.dataset.key)) return;
      select.dataset.tsBqSortReady = 'true';
      select.disabled = false;
      select.addEventListener('change', () => {
        if (!['price', 'count'].includes(select.value)) return;
        const keyOrder = (a, b) => a.dataset.key < b.dataset.key ? -1 : a.dataset.key > b.dataset.key ? 1 : 0;
        const compare = select.value === 'count'
          ? (a, b) => Number(b.dataset.count) - Number(a.dataset.count) || keyOrder(a, b)
          : (a, b) => Number(a.dataset.price) - Number(b.dataset.price) || keyOrder(a, b);
        rows.slice().sort(compare).forEach((row) => container.appendChild(row));
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('timeseek:public-market-mounted', (event) => initialize(event.target));
})();
